import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import ReduxThunk from 'redux-thunk';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import _ from 'lodash';
import { PopupProvider } from "./context/PopupContext";
import ConfirmationPopup from "./components/popup/ConfirmationPopup";
import SharePopup from "./components/popup/SharePopup";
import DownloadPopup from "./components/popup/DownloadPopup";
import DuplicatePopup from './components/popup/DuplicatePopup';
import RenamePopup from './components/popup/RenamePopup';
import AlertPopup from './components/popup/AlertPopup';
// import '../src/scss/style.scss';
import '../src/assets/scss/app/app.scss';
import '../src/assets/fonts/icomoon.css';

import { LOGIN_LINK, LOGIN_PROGRESS_LINK, EDITOR_LINK, SIGNUP_LINK, CHOOSE_COLOR, CREATE_RESUME, UPLOAD_RESUME, EDITOR_PAGES, FINAL_RESUME, DASHBOARD_LINK, LOGOUT_LINK, RESET_LINK, FORGET_LINK, FORGOT_LINK, CHOOSE_EDITOR, MEMBERSHIP, CHECKOUT, MY_ACCOUNT, EDIT_PROFILE, CHANGE_PASSWORD, INVOICES, PAID_SERVICES, RESUME_LINK, FULLSTORY_ORG_ID,SENTRY_REPO_URL, MEMBERSHIP_CANCELLATION, RESET_PASSWORD, SEARCH_PARAMS, COOKIE_DOMAIN, COVERLETTER_LINK, COVERLETTER_SHARE_LINK, COVERLETTER_SHAREPDF_LINK, COVERLETTER_PAGES, BUILD_COVERLETTER, COVERLETTER_EXPERIENCE, UPDATE_PAYMENT_INFO, PAYMENT_METHODS, REFRESH_LINK, RECAPTCHA_SITE_KEY} from './constants/constants';
import editorReducer from './services/reducers/editorReducer';
import WpAPI from './WpApi';
// import Header from './containers/HeaderContainer';
import HeaderShareResume from './containers/HeaderShareResumeContainer';
import SimpleHeader from './components/common/SimpleHeader';
import Dashboard from './components/Dashboard';
import Footer from './components/common/Footer';
// import CreateResume from './components/CreateResume';
import EditorContainer from './containers/EditorContainer';
// import Resetpassword from './components/user/ResetPassword';
// import ForgetPassword from './components/user/ForgetPassword';
// import Login from './components/user/Login'
// import Signup from './components/user/Signup';
// import ChooseTemplate from './components/ChooseTemplate';
// import UploadResume from './components/UploadResume';
// import QuickEditorContainer from './containers/QuickEditorContainer';
import PageLoader from './components/common/PageLoader';
import Loader from './components/common/Loader';
import Version from './Version';
import LoginProgress from './components/user/LoginProgress';
// import { init as FullStoryInit } from '@fullstory/browser';

import * as Sentry from "@sentry/react";
import { UserProvider } from './context/UserContext';
import Cookies from 'js-cookie';
import AISearchTitlePopup from './components/popup/AISearchTitlePopup';
import CoverLetterContainer from './containers/CoverLetterContainer';
import WaitingPopup from './components/popup/WaitingPopup';
import PaymentMethods from './components/membership/PaymentMethods';
import Empty from './components/common/Empty';
import AskforReviewPopup from './components/popup/AskforReviewPopup';
import { isLocalStorageAvailable } from './helper';
// import ShareLetter from './components/coverletter/ShareLetter';

// const  Header = React.lazy(() => import('./components/common/HeaderComponent'));
const CreateResume = React.lazy(() => import('./components/CreateResume'));
// const EditorContainer = React.lazy(() => import('./containers/EditorContainer'));
const Login = React.lazy(() => import('./containers/LoginContainer'));
const Logout = React.lazy(() => import('./components/user/Logout'));
const Signup = React.lazy(() => import('./components/user/Signup'));
//const Resetpassword = React.lazy(() => import('./components/user/ResetPassword'));
const ResetPassword = React.lazy(() => import('./components/user/ResetPassword'));
const ForgetPassword = React.lazy(() => import('./components/user/ForgetPassword'));
const ChooseTemplate = React.lazy(() => import('./components/ChooseTemplate'));
const UploadResume = React.lazy(() => import('./components/UploadResume'));
const QuickEditorContainer = React.lazy(() => import('./containers/QuickEditorContainer'));
const ChooseEditor = React.lazy(() => import('./components/ChooseEditor'));
const Membership = React.lazy(() => import('./components/membership/Membership'));
const MyAccount = React.lazy(() => import('./components/membership/MyAccount'));
const EditProfile = React.lazy(() => import('./components/membership/EditProfile'));
const ChangePassword = React.lazy(() => import('./components/membership/ChangePassword'));
const Invoices = React.lazy(() => import('./components/membership/Invoices'));
const Checkout = React.lazy(() => import('./components/membership/Checkout'));
const UpdatePaymentInfo = React.lazy(() => import('./components/membership/UpdatePaymentInfo'));
const ShareResume = React.lazy(() => import('./components/ShareResume'));
const ResumeLink = React.lazy(() => import('./components/ResumeLink'));
const ShareLetter = React.lazy(() => import('./components/coverletter/ShareLetter'));
const LetterPdfLink = React.lazy(() => import('./components/coverletter/LetterPdfLink'));
const CreateResumeWithTemplate = React.lazy(() => import('./components/CreateResumeWithTemplate'));
const BuildCoverLetter = React.lazy(() => import('./components/coverletter/LandingPage'));
const CreateResumeWithShowcase = React.lazy(() => import('./components/CreateResumeWithShowcase'));
const AdminOptions = React.lazy(() => import('./components/AdminOptions'));
const MembershipCancellation = React.lazy(() => import('./components/membership/MembershipCancellation'));

const store = createStore(editorReducer, ENV == 'prod' ? applyMiddleware(ReduxThunk) : composeWithDevTools(applyMiddleware(ReduxThunk)));

let hasRunOnce = false;

function onRender() {
  if (!hasRunOnce) {
    if (_.indexOf(EDITOR_PAGES, window.location.pathname) != -1 
    || window.location.pathname.startsWith(LOGIN_LINK) 
    || window.location.pathname.startsWith(RESET_LINK) 
    || window.location.pathname.startsWith(MY_ACCOUNT) 
    || window.location.pathname.startsWith(MEMBERSHIP)
    || window.location.pathname.startsWith(CHECKOUT) 
    || window.location.pathname.startsWith(UPDATE_PAYMENT_INFO) 
    || window.location.pathname.startsWith(INVOICES) 
    || window.location.pathname.startsWith(PAYMENT_METHODS) 
    || window.location.pathname.startsWith(CHOOSE_COLOR)
    || window.location.pathname.startsWith(COVERLETTER_EXPERIENCE)
    || window.location.pathname == "/") {
      WpAPI.getLoginUser(store.dispatch).then((is_loggedin) => {
        if (isLocalStorageAvailable()) {
            WpAPI.fetchActiveResume(store.dispatch, () => {
              // if(is_loggedin && PAID_SERVICES){
              //   WpAPI.membership(store.dispatch, store.getState().plan, store.getState().lastsync, false, false).then(res => {
              //     //do something..
              //   })
              // }
              hasRunOnce = true;
              // code change to force dashboard to load on page refresh (third parameter)
              // (window.location.pathname == "/") && WpAPI.loadCoverLettersInDashboard(false, true)
              //Version.flush();
              //code change to force dashboard to load on page refresh  (third parameter)
            }, (window.location.pathname === "/") && true);
        } else {
          console.warn("localStorage is not available.");
        }
      })
    }
  }

  // if(ENV == 'prod'){
  //   FullStoryInit({ orgId: FULLSTORY_ORG_ID }, ( { sessionUrl }) => {
  //     //return console.log(`Started session: ${sessionUrl}`);
  //     return console.log(`Started session`);
  //   });
  // }

  if(SEARCH_PARAMS.has('utm_source')){
    const rb_utm_source = Cookies.get('rb_utm_source', { domain: COOKIE_DOMAIN, path: '/' });
    if(typeof rb_utm_source == 'undefined' || rb_utm_source == null){
      Cookies.set('rb_utm_source', SEARCH_PARAMS.get('utm_source'), { domain: COOKIE_DOMAIN, path: '/' });
    }
  }
}

(['prod','stag'].indexOf(ENV) !== -1) && Sentry.init({
  environment: (ENV == 'prod' ? 'production' : ENV),
  dsn: SENTRY_REPO_URL,
  integrations: [
    new Sentry.BrowserTracing({
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ["app.resumebuilder.com","stagingapp.resumetemplates.com"],
    }),
    // new Sentry.Replay({
    //   networkDetailAllowUrls: ['/wp-admin/admin-ajax.php','/api/*'],
    // }),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
  // Session Replay
  //replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  //replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const app = document.getElementById('app');
let loader = document.getElementById('loader');
loader.style.display = "none";
ReactDOM.render(
  <div className="wrapper">
    <Provider store={store}>
    <UserProvider>
      <PopupProvider>
        <Router>
          <Switch>
            <Route exact path={REFRESH_LINK}>
              <Suspense fallback={<PageLoader />}>
                <Empty />
              </Suspense>
            </Route>
            <Route exact path={CREATE_RESUME}>
              <SimpleHeader showSplash={true} />
              <div className="create-resume-initial-wrap">
                <Suspense fallback={<PageLoader />}>
                  <CreateResume />
                </Suspense>
              </div>
              <Footer />
            </Route>
            <Route exact path={CHOOSE_COLOR}>
              <SimpleHeader />
              <div className="template-selector-screen">
                <Suspense fallback={<PageLoader />}>
                  <ChooseTemplate />
                </Suspense>
              </div>
              <Footer />
            </Route>
            <Route exact path={UPLOAD_RESUME}>
              <SimpleHeader />
              <div className="upload-wrap">
                <Suspense fallback={<PageLoader />}>
                  <UploadResume />
                </Suspense>
              </div>
              <Footer />
            </Route>
            {/* <Route exact path={CHOOSE_EDITOR}>
              <SimpleHeader />
              <div className="upload-wrap">
                <Suspense fallback={<PageLoader />}>
                  <ChooseEditor />
                </Suspense>
              </div>
              <Footer />
            </Route> */}
            <Route path={`${CHECKOUT}:id?`}>
              {/* <SimpleHeader /> */}
              <div className="checkout-wrap" style={{ minHeight: '100vh' }}>
                <Suspense fallback={<PageLoader />}>
                  <Checkout />
                </Suspense>
              </div>
              <Footer />
            </Route>
            <Route path={`${UPDATE_PAYMENT_INFO}:id?`}>
              <div className="payment-method-wrap" style={{ minHeight: '100vh' }}>
                <Suspense fallback={<PageLoader />}>
                  <UpdatePaymentInfo />
                </Suspense>
              </div>
              <Footer />
            </Route>
            <Route exact path={MEMBERSHIP}>
              {/* <SimpleHeader /> */}
              <div className="upload-wrap">
                <Suspense fallback={<PageLoader />}>
                  <Membership />
                </Suspense>
              </div>
              <Footer />
            </Route>
            <Route exact path={MY_ACCOUNT}>
              <SimpleHeader />
              <div className="upload-wrap">
                <Suspense fallback={<PageLoader />}>
                  <MyAccount />
                </Suspense>
              </div>
              <Footer />
            </Route>
            <Route exact path={MEMBERSHIP_CANCELLATION}>
              <SimpleHeader />
              <div className="upload-wrap">
                <Suspense fallback={<PageLoader />}>
                  <MembershipCancellation />
                </Suspense>
              </div>
              <Footer />
            </Route>
            <Route exact path={EDIT_PROFILE}>
              <SimpleHeader />
              <div className="upload-wrap">
                <Suspense fallback={<PageLoader />}>
                  <EditProfile />
                </Suspense>
              </div>
              <Footer />
            </Route>
            <Route exact path={CHANGE_PASSWORD}>
              <SimpleHeader />
              <div className="upload-wrap">
                <Suspense fallback={<PageLoader />}>
                  <ChangePassword />
                </Suspense>
              </div>
              <Footer />
            </Route>
            <Route exact path={INVOICES}>
              <SimpleHeader />
              <div className="upload-wrap">
                <Suspense fallback={<PageLoader />}>
                  <Invoices />
                </Suspense>
              </div>
              <Footer />
            </Route>
            <Route exact path={PAYMENT_METHODS}>
              <SimpleHeader />
              <div className="upload-wrap">
                <Suspense fallback={<PageLoader />}>
                  <PaymentMethods />
                </Suspense>
              </div>
              <Footer />
            </Route>
            <Route exact path={LOGIN_LINK}>
              <SimpleHeader  className={`blue-header`}/>
              <div className="login-register" id="login-register">
              <Suspense fallback={<PageLoader imageColor="white" />}>
                  <Login redirect={'/'} />
                </Suspense>
              </div>
              <Footer className={`blue-footer`}/>
            </Route>
            <Route exact path={LOGIN_PROGRESS_LINK}>
              <HeaderShareResume showSplash={false} />
              <div className="login-wrap">
                <Suspense fallback={<div>&nbsp;</div>}>
                  <LoginProgress />
                </Suspense>
              </div>
              <Footer className={`blue-footer`}/>
            </Route>
            <Route exact path={LOGOUT_LINK}>
              <SimpleHeader />
              <div className="logout-wrap">
                <Suspense fallback={<PageLoader />}>
                  <Logout />
                </Suspense>
              </div>
              <Footer />
            </Route>
            <Route exact path={SIGNUP_LINK}>
              <SimpleHeader className={`blue-header`}/>
              <div className="login-register register" id="register">
                <Suspense fallback={<PageLoader imageColor="white" />}>
                  <Signup redirect={'/'} />
                </Suspense>
              </div>
              <Footer className={`blue-footer`}/>
            </Route>
            <Route exact path={RESET_PASSWORD}>
              <SimpleHeader />
              <div className="login-wrap">
              <Suspense fallback={<PageLoader imageColor="white" />}>
                  <ResetPassword />
                </Suspense>
              </div>
              <Footer className={`blue-footer`}/>
            </Route>
            <Route exact path={FORGET_LINK}>
              <SimpleHeader className={`blue-header`} />
              <div className="login-wrap">
              <Suspense fallback={<PageLoader imageColor="white" />}>
                  <ForgetPassword />
                </Suspense>
              </div>
              <Footer className={`blue-footer`}/>
            </Route>
            <Route exact path={FORGOT_LINK}>
              <SimpleHeader className={`blue-header`} />
              <div className="login-wrap">
              <Suspense fallback={<PageLoader imageColor="white" />}>
                  <ForgetPassword />
                </Suspense>
              </div>
              <Footer className={`blue-footer`}/>
            </Route>
            {/* <Route exact path={DASHBOARD_LINK}>
              <Header /> <Dashboard />
            </Route> */}
            {/* Additional pages start */}

            <Route exact path={FINAL_RESUME}>
              {/*task 352. Add a banner for subscription revert and want to show splash message below in quick editor so disabling in header component.*/}
              {/* <SimpleHeader showDownload={true} cssClass={'simple-header'} /> */}
              {/* <div className="preview-page-wrap"> */}
              <div className="quick-editor-screen">
                <Suspense fallback={<PageLoader />}>
                  <QuickEditorContainer />
                </Suspense>
              </div>
              {/* <Footer className="quick-editor-footer" /> */}
            </Route>
            <Route path="/r/:id">
              <Suspense fallback={<PageLoader />}>
                <HeaderShareResume />
                <ShareResume />
              </Suspense>
            </Route>
            <Route path="/create-resume-tpl/:id/:colorcode?">
              <Suspense fallback={<PageLoader />}>
                <CreateResumeWithTemplate />
              </Suspense>
            </Route>
            <Route path= {RESUME_LINK}>
              <Suspense fallback={<PageLoader />}>
                <ResumeLink />
              </Suspense>
            </Route>
            <Route path="/create-resume-with-showcase/:showcase_id">
              <Suspense fallback={<PageLoader />}>
                <CreateResumeWithShowcase />
              </Suspense>
            </Route>
            <Route path={`${BUILD_COVERLETTER}`}>
              <SimpleHeader />
              <Suspense fallback={<PageLoader />}>
                <BuildCoverLetter />
              </Suspense>
              <Footer />
            </Route>
            <Route path={COVERLETTER_LINK}>
              {/* <Header /> */}
              {/* <Suspense fallback={'Loading...'}> */}
              <CoverLetterContainer />
              {/* </Suspense> */}
              {/* <Footer className="edit-editor-footer" /> */}
            </Route>
            <Route path={EDITOR_LINK}>
              {/* <Header /> */}
              {/* <Suspense fallback={'Loading...'}> */}
              <EditorContainer />
              {/* </Suspense> */}
              {/* <Footer className="edit-editor-footer" /> */}
            </Route>
            <Route path={COVERLETTER_SHARE_LINK}>
              <Suspense fallback={<PageLoader />}>
                <HeaderShareResume />
                <ShareLetter />
              </Suspense>
            </Route>
            <Route path={COVERLETTER_SHAREPDF_LINK}>
              <Suspense fallback={<PageLoader />}>
                <LetterPdfLink />
              </Suspense>
            </Route>
            <Route path="/admin-options/:resume_id">
              <Suspense fallback={<PageLoader />}>
                <SimpleHeader />
                <AdminOptions />
              </Suspense>
            </Route>
            <Route exact path="">
              {/* <Header /> */}
              <SimpleHeader />
              <Dashboard />
              <Footer />
            </Route>
            {/* Additional pages end */}
          </Switch>
        </Router>
        <ConfirmationPopup />
        <SharePopup />
        <DownloadPopup />
        <DuplicatePopup />
        <RenamePopup />
        <AlertPopup />
        <AISearchTitlePopup />
        <WaitingPopup />
        <AskforReviewPopup />
      </PopupProvider>
      </UserProvider>
    </Provider>
  </div>,
  app, onRender
);
